export type { UsedBonusReportTranslations } from "./used-bonus-report-pt-br";
export { USED_BONUS_REPORT_PT_BR } from "./used-bonus-report-pt-br";
export { USED_BONUS_REPORT_EN_US } from "./used-bonus-report-en-us";
export { USED_BONUS_REPORT_ES_MX } from "./used-bonus-report-es-mx";
export { USED_BONUS_REPORT_FR_FR } from "./used-bonus-report-fr-fr";
